export default {"src":"/login-app/[GIT_HASH]/_next/static/media/git_repository.35201c22.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};